import { GetQueryParameter } from "./Url";

export const checkLanguageGerman = () => {
    if (GetQueryParameter("locale").startsWith("de") || GetQueryParameter("language") === "de") {
        return true;
    }
    return false;
}